import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { Input } from "rbx";

// import { format, isValid, parseISO } from "date-fns";
// import moment from "moment";

function DateInput({
  name,
  label,
  value: initialValue,
  onChange,
  disabled = false,
  readOnly = false,
  ...props
}) {
  const [value, setValue] = useState((initialValue || "").substr(0, 10));

  const handleChange = e => {
    setValue(e.target.value);
  };

  useEffect(() => {
    setValue((initialValue || "").substr(0, 10));
  }, [initialValue]);

  const handleBlur = () => {
    if (!disabled && !readOnly) {
      onChange({
        target: {
          name,
          value
        }
      });
    }
  };
  return (
    <Input
      autoComplete="new"
      type="date"
      {...props}
      disabled={disabled}
      id={label}
      name={name}
      readOnly={readOnly}
      value={value}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
}

DateInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.instanceOf(Date)
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool
};

export default DateInput;
